function minicartApp() {
  return {
    show: false,
    loader: false,
    changeTimeout: null,
    toggleMinicart(e) {
      e.preventDefault();
      if (!this.isCartPage()) {
        this.show = !this.show;
      }
    },
    isCartPage() {
      let _is_cart_page = false;

      _is_cart_page = document.location.href.includes('/cart') ? true : false;

      return _is_cart_page;
    },
    removeItem(key) {
      this.loader = true;
      const data = {
        id: key,
        quantity: 0,
      };

      axios
        .post('/cart/change.js', data)
        .then(() => {
          this.dispatchEvent('cartUpdated');
        })
        .catch((e) => {
          console.log('e', e);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    handleQtyIncrease(item) {
      if (this.changeTimeout) {
        clearTimeout(this.changeTimeout);
      }
      if (item._is_uom_variant) {
        item.quantity += item._uom_qty;
      } else {
        item.quantity += 1;
      }

      this.changeTimeout = setTimeout(() => {
        this.loader = true;
        const data = {
          id: item.key,
          quantity: item.quantity,
        };

        axios
          .post('/cart/change.js', data)
          .then(() => {
            this.dispatchEvent('cartUpdated');
          })
          .catch((e) => {
            console.log('e', e);
          })
          .finally(() => {
            this.loader = false;
          });
      }, 1000);
    },
    handleQtyDecrease(item) {
      if (item.quantity > 0) {
        if (this.changeTimeout) {
          clearTimeout(this.changeTimeout);
        }

        if (item._is_uom_variant) {
          item.quantity -= item._uom_qty;
        } else {
          item.quantity -= 1;
        }

        this.changeTimeout = setTimeout(() => {
          this.loader = true;
          const data = {
            id: item.key,
            quantity: item.quantity,
          };

          axios
            .post('/cart/change.js', data)
            .then(() => {
              this.dispatchEvent('cartUpdated');
            })
            .catch((e) => {
              console.log('e', e);
            })
            .finally(() => {
              this.loader = false;
            });
        }, 1000);
      }
    },
    getPrice(item) {
      let _price = item.price;
      return this.formatPrice(_price);
    },
    getDiscountedPrice(item) {
      let _price = item.discounted_price;
      return this.formatPrice(_price);
    },
    getUomVariantDiscountMessage(item) {
      if (item.line_level_discount_allocations.length) {
        return item.line_level_discount_allocations[0].discount_application
          .title;
      } else {
        return '';
      }
    },
    handleInputQtyChanged(e, item) {
      let _qty = e.target.value;

      if (_qty < 0) {
        _qty = 0;
      }

      if (_qty > 0 && _qty % item._uom_qty !== 0) {
        _qty = item._uom_qty;
      }

      this.loader = true;
      const data = {
        id: item.key,
        quantity: _qty,
      };

      axios
        .post('/cart/change.js', data)
        .then(() => {
          this.dispatchEvent('cartUpdated');
        })
        .catch((e) => {
          console.log('e', e);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    handleQtyChanged(item) {
      this.loader = true;
      const data = {
        id: item.key,
        quantity: item.quantity,
      };

      axios
        .post('/cart/change.js', data)
        .then(() => {
          this.dispatchEvent('cartUpdated');
        })
        .catch((e) => {
          console.log('e', e);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    isUomVariant(item) {
      return Boolean(item._is_uom_variant);
    },
    isDiscount(item) {
      let _is_discount = false;

      if (item.discounted_price != item.price) {
        return true;
      }

      return _is_discount;
    },
    isOptionVariant(item) {
      return item._is_option_variant;
    },
    isAutoAdded(item) {
      return item._is_option_variant;
    },
    isPublicProperty(propId) {
      return propId.charAt(0) != '_';
    },
    formatSubtotal(subtotal = 0) {
      return Shopify.formatMoney(subtotal, Shopify.moneyFormat);
    },
    formatPrice(price) {
      return Shopify.formatMoney(price, Shopify.moneyFormat);
    },
    dispatchEvent(name) {
      const event = new Event(name);
      document.dispatchEvent(event);
    },
  };
}
